import "./MessageStatusBadge.css";
import {
  MessageLogStatus,
  MESSAGE_LOG_STATUS_CLASS,
  MESSAGE_LOG_STATUS_LABELS,
} from "../../../models/MessageModels";

interface MessageStatusBadgeProps {
  status: number;
}

const MessageStatusBadge = ({ status }: MessageStatusBadgeProps) => {
  const key = status as MessageLogStatus;
  const label = MESSAGE_LOG_STATUS_LABELS[key] ?? "Unknown";
  const cls = MESSAGE_LOG_STATUS_CLASS[key] ?? "pending";

  return (
    <span
      className={`msg-status msg-status--${cls}`}
      title="Sent = message prepared / WhatsApp opened. True delivery reports need provider integration later."
    >
      {label}
    </span>
  );
};

export default MessageStatusBadge;